"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useConnectionStatus = void 0;
var react_1 = require("react");
var useDitto_1 = require("../useDitto");
var useConnectionStatus = function (params) {
    var ditto = (0, useDitto_1.useDitto)(params.path).ditto;
    var _a = (0, react_1.useState)(false), isConnected = _a[0], setIsConnected = _a[1];
    var peersObserverRef = (0, react_1.useRef)();
    (0, react_1.useEffect)(function () {
        if (ditto) {
            peersObserverRef.current = ditto.presence.observe(function (_a) {
                var remotePeers = _a.remotePeers;
                var nextActiveConnections = remotePeers.reduce(function (acc, peer) {
                    peer.connections.forEach(function (connection) {
                        return acc.add(connection.connectionType);
                    });
                    return acc;
                }, new Set());
                if (Array.from(nextActiveConnections).includes(params.forTransport)) {
                    setIsConnected(true);
                }
                else {
                    setIsConnected(false);
                }
            });
            return function disconnect() {
                if (peersObserverRef.current) {
                    peersObserverRef.current.stop();
                }
            };
        }
    }, [ditto, params.forTransport]);
    return isConnected;
};
exports.useConnectionStatus = useConnectionStatus;
//# sourceMappingURL=useConnectionStatus.js.map